module.exports = __webpack_public_path__ + "img/bar2.632889b9.png";